import React from 'react';
import styled from 'styled-components';

import Image3 from '../../../../containers/assets/onboarding-gameoverview-image3.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const GameOverviewStep3 = () => (
  <Wrapper>
    <Text1>Game Overview</Text1>
    <Text2>The Goals &amp; Targets</Text2>
    <Text3>
      The goal of the game is for the teams to hit <b>financial targets</b> on
      a set of 4 metrics that change each round.
    </Text3>
    <Image>
      <img src={Image3} alt="" />
    </Image>
  </Wrapper>
);

export default GameOverviewStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/game-overview/step3.js